<script>
export default {
  methods: {
    getCallTaskState (state) {
      if (this.$i18n && this.$i18n.locale && this.$i18n.messages && this.$i18n.messages[this.$i18n.locale]) {
        return this.$i18n.messages[this.$i18n.locale].callTasks.states[state.toLowerCase()]
      } else {
        switch (state) {
          case 'FAILED':
            return 'Недозвон'
          case 'DIALING':
            return 'Вызов'
          case 'ONGOING':
            return 'Идет разговор'
          case 'PERFORMED':
            return 'Выполнена'
          case 'POSTPONED':
            return 'Отложена'
          case 'READY':
            return 'В очереди'
          case 'TELEPHONY_ERROR_SUSPEND':
            return 'Отложена'
          case 'CANCELLED':
            return 'Отменена'
          default:
            return state
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// GetCalltaskState.vue?3c6cda09